import { api } from "../client";
import { CommissionChangelog } from "../schema/CommissionChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<CommissionChangelog[]>;

export const getCommissionChangelog = async (
  commissionId: number,
  config?: ApiRequestConfig
) => {
  return api.get<CommissionChangelog[]>(
    `commissions/${commissionId}/commission_histories`,
    config
  );
};
